var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1658_3120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12C18.75 12.1492 18.6907 12.2923 18.5852 12.3977C18.4798 12.5032 18.3367 12.5625 18.1875 12.5625H12.5625V18.1875C12.5625 18.3367 12.5032 18.4798 12.3977 18.5852C12.2923 18.6907 12.1492 18.75 12 18.75C11.8508 18.75 11.7077 18.6907 11.6023 18.5852C11.4968 18.4798 11.4375 18.3367 11.4375 18.1875V12.5625H5.8125C5.66332 12.5625 5.52024 12.5032 5.41475 12.3977C5.30926 12.2923 5.25 12.1492 5.25 12C5.25 11.8508 5.30926 11.7077 5.41475 11.6023C5.52024 11.4968 5.66332 11.4375 5.8125 11.4375H11.4375V5.8125C11.4375 5.66332 11.4968 5.52024 11.6023 5.41475C11.7077 5.30926 11.8508 5.25 12 5.25C12.1492 5.25 12.2923 5.30926 12.3977 5.41475C12.5032 5.52024 12.5625 5.66332 12.5625 5.8125V11.4375H18.1875C18.3367 11.4375 18.4798 11.4968 18.5852 11.6023C18.6907 11.7077 18.75 11.8508 18.75 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1658_3120",
    x: -24,
    y: -24,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1658_3120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1658_3120",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.2a3c494b008db2a8f119fa349e095fd7.svg";
export { ForwardRef as ReactComponent };